import { createStore } from 'jotai';

/**
 * There is a bug with devtools tha trequires the DevTools be imported before you create the store
 *
 * https://github.com/jotaijs/jotai-devtools/discussions/197
 *
 * To work around this we are reexporting DevTools before initiating createStore.
 *
 */

export { DevTools } from 'jotai-devtools';
export const jotaiStore = createStore();
